<template>
  <div
    v-if="loaded && reports.length > 0"
    id="resources"
    class="h-auto w-full relative justify-center items-center overflow-y-visible m-auto p-12 py-28 bg-gray-100"
  >
    <h2
      v-if="heading"
      class="font-light m-auto ml-0 w-full max-w-7xl mb-12 text-center lg:text-left"
    >
      {{ heading }}
    </h2>

    <div class="w-full flex flex-col items-center justify-center">
      <div class="w-full max-w-7xl">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div
            v-for="(item, i) in reports"
            :id="item.id"
            :key="i"
            :ref="'resources-' + i"
            :style="[
              item.type === 1
                ? {
                    background:
                      'linear-gradient(223.93deg, #FE4A49 8.36%, rgba(254, 74, 73, 0.2) 65.47%), #05162E',
                  }
                : { background: '#fff' },
            ]"
            :class="'rounded-xl px-6 pt-8 pb-4 group hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 ease-in-out cursor-pointer flex flex-col justify-center'"
            @click="goToOrDownloadResource(item)"
          >
            <h6
              class="font-poppins group-hover:text-expo_red transition-all duration-300 ease-in-out font-bold upper-case"
              :class="
                item.type === 1
                  ? 'text-white'
                  : 'text-truegray-300 group-hover:text-expo_red'
              "
            >
              CAREERS EXPO <span v-if="item.type === 0">- Article</span>
              <span v-if="item.type === 1">- Download Attachment</span>
            </h6>
            <h4
              class="text-lg font-poppins mb-4"
              :class="item.type === 1 ? 'text-white' : 'text-black'"
            >
              {{ item.title }}
            </h4>
            <p
              v-if="item.type !== 1"
              class="text-right text-truegray-500 font-bold hover:text-expo_red"
            >
              Read more
              <span
                class="transition-all duration-300 ease-in-out transform hover:translate-x-4"
                >></span
              >
            </p>
          </div>
        </div>
        <!-- PAGINATION -->
        <div
          v-if="
            (pagination.previouspage || pagination.nextpage) && showPagination
          "
          class="flex justify-between items-center h-10"
        >
          <span
            :disabled="!pagination.previouspage"
            :class="[
              !pagination.previouspage
                ? 'opacity-25 cursor-not-allowed'
                : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
            ]"
            class="text-gray-500"
            @click="navigate(pagination.previouspage)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 17l-5-5m0 0l5-5m-5 5h12"
              />
            </svg>
          </span>
          <span class="text-center text-xs"
            >Page {{ pagination.current_page }} of
            {{ pagination.total_pages }}</span
          >
          <span
            :disabled="!pagination.nextpage"
            :class="[
              !pagination.nextpage
                ? 'opacity-25 cursor-not-allowed'
                : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
            ]"
            class="text-gray-500"
            @click="navigate(pagination.nextpage)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fileHandling } from '../../../js/mixins/fileHandling.js'
import { EventBus } from '../../../js/plugins/event-bus.js'

export default {
  mixins: [fileHandling],

  props: {
    heading: { default: false },
    category: { default: false },
    type: { default: false },
    region: { default: false },
    paginate: { default: false },
    feature: { default: false },
  },

  data() {
    return {
      loaded: false,
      reports: [],
      listScoping: {},
      showPagination: false,
      pagination: {
        current_page: null,
        total_pages: null,
        per_page: 12,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
      },
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
    }),
  },

  mounted() {
    if (this.paginate) {
      this.$set(this, 'showPagination', true)
      this.$set(this.listScoping, 'paginate', this.paginate)
    }

    // Set the properties if they exists...
    if (this.category) {
      this.$set(this.listScoping, 'category', this.category)
    }
    if (this.region) {
      this.$set(this.listScoping, 'region', this.region)
    }
    if (this.type) {
      this.$set(this.listScoping, 'type', this.type)
    }
    if (this.feature) {
      this.$set(this.listScoping, 'feature', this.feature)
    }
    this.getLatestNewsAndResources()
  },

  methods: {
    navigate(gotopage = null) {
      // Pagination page?
      if (gotopage) {
        this.$set(this.listScoping, 'page', gotopage)
      } else {
        this.$set(this.listScoping, 'page', null)
      }
      this.getLatestNewsAndResources()
    },

    getLatestNewsAndResources() {
      axios
        .post('/api/get-type-category-resources', this.listScoping)
        .then((response) => {
          if (response.data.reports) {
            this.$set(this, 'reports', response.data.reports)

            if (this.with_pagination) {
              // pagination.total = total # of posts. / by per_page, + 1. Pagination doesnt show when not needed so +1 is never wrong on single page
              let total_pages =
                Math.floor(
                  response.data.pagination.total /
                    response.data.pagination.per_page,
                ) + 1
              this.$set(
                this.pagination,
                'current_page',
                response.data.pagination.current_page,
              )
              this.$set(this.pagination, 'total_pages', total_pages)
              this.$set(
                this.pagination,
                'per_page',
                response.data.pagination.per_page,
              )
              this.$set(
                this.pagination,
                'last_page_url',
                response.data.pagination.last_page_url,
              )
              this.$set(
                this.pagination,
                'next_page_url',
                response.data.pagination.next_page_url,
              )
              this.$set(
                this.pagination,
                'prev_page_url',
                response.data.pagination.prev_page_url,
              )
              this.$set(
                this.pagination,
                'path',
                response.data.pagination.next_page_path,
              )

              let prev = null
              if (this.pagination.prev_page_url) {
                prev = this.pagination.prev_page_url.split('=')
                prev = prev[1]
              }

              let next = null
              if (this.pagination.next_page_url) {
                next = this.pagination.next_page_url.split('=')
                next = next[1]
              }

              this.$set(this.pagination, 'previouspage', prev)
              this.$set(this.pagination, 'nextpage', next)
            }

            this.$set(this, 'loaded', true)
            let reportsLength = response.data.reports.length
            EventBus.$emit('resourcesLoaded', reportsLength)
          }
        })
    },

    goToOrDownloadResource(item) {
      if (item.file && item.type === 1) {
        this.downloadPdfFromEndpoint('/api/download-resource-pdf/' + item.id)
      } else {
        if (this.settings.is_landlord) {
          // We need to go to the cloud listing for this ...
          window.location.href =
            this.settings.cloud_url + '/resource/' + item.id
        } else {
          // We are not in the landlord we can use vue router ...
          this.$router.push('/resource/' + item.id)
        }
      }
    },
  },
}
</script>
